// extracted by mini-css-extract-plugin
export var numpadContainer = "_jr-1";
export var phoneButton = "_jr-0";